module.exports = __webpack_public_path__ + "static/media/spinner.04c86d0c.gif";